import(/* webpackMode: "eager" */ "/app/fe/src/app/not-found.tsx");
